import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupUpdateAdminsContentProps } from './msg-group-update-admins-content';
import { MsgGroupUpdateAdminsContent } from './msg-group-update-admins-content';

export interface MsgGroupUpdateAdminsPreviewProps extends MsgGroupUpdateAdminsContentProps {}

export const MsgGroupUpdateAdminsPreview = memo(function MsgGroupUpdateAdminsPreview({
  message,
}: MsgGroupUpdateAdminsPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupUpdateAdminsContent message={message} />
    </LastMessageSystem>
  );
});
